import script from "./BaTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaTabs.vue?vue&type=script&setup=true&lang=ts"

import "./BaTabs.vue?vue&type=style&index=0&id=fe5dffb4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe5dffb4"]])

export default __exports__